export enum tokenLinkReducers {
    generatedTokenLink = 'generatedTokenLink'
}